import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'
import segment from '@analytics/segment'

import sendinblue from './analytics-plugin-sendinblue'

const analytics = Analytics({
    app: 'devv-webapp',
    plugins: [
        googleTagManager({
            containerId: process.env.NEXT_PUBLIC_GTM_ID,
            enabled: true,
        }),
        segment({
            writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
            enabled: true,
        }),
        sendinblue({
            client_key: process.env.NEXT_PUBLIC_SENDINBLUE_CLIENT_KEY || '',
            enabled: true,
        }),
    ],
})

export const AnalyticsEvents = {
    Enroll: 'enroll',
    PreEnroll: 'pre-enroll',
}

export default analytics
